export default {
  free: {
    price: 0,
    additionalTenProfiles: 10,
  },
  base: {
    price: 89,
    additionalUser: 10
  },
  team: {
    price: 159, 
    additionalUser: 20
  },
  enterprise: {
    price: 299,
    additionalUser: 25,
    additionalThousandProfiles: 209
  }
}

export const FREE_TARIFF_NAME = 'free';
export const BASE_TARIFF_NAME = 'base';
export const TEAM_TARIFF_NAME = 'team';
export const ENTERPRISE_TARIFF_NAME = 'enterprise';
export const TRIAL_PERIOD_NAME = 'trial';
export const PAYMENT_METHOD_CARD_NAME = 'card';
export const PAYMENT_METHOD_UNLIMINT_NAME = 'unlimint';
export const PAYMENT_METHOD_CRYPTO_NAME = 'crypto';
export const PAYMENT_METHOD_CAPITALIST_NAME = 'capitalist';
export const PAYMENT_METHOD_WALLET_NAME = 'wallet';
export const PAYMENT_METHOD_USDT_NAME = 'usdt';
export const PAYMENT_METHOD_CLOUDPAYMENTS_NAME = 'cloudpayments';
export const PAYMENT_METHOD_CLOUDPAY_NAME = 'cloudpaymentsOrFreekassa';
export const PAYMENT_METHOD_CRYPTOMUS_OR_INXY = 'cryptomusOrINXY';
export const PAYMENT_METHOD_FREEKASSA_NAME = 'freekassa';
export const PAYMENT_METHOD_INXY_NAME = 'inxy';
export const PAYMENT_METHOD_CRYPTOMUS_NAME = 'cryptomus';
export const PAYMENT_METHOD_STRIPE = 'stripe';

export const USDT_TRC20_CODE = 'USDT (TRC20)';
export const USDT_ERC20_CODE = 'USDT (ERC20)';
export const USDC_BSC_CODE = 'USDC (BSC)';
export const USDT_BEP20_CODE = 'USDT (BEP20)';
export const USDT_CODE = 'USDT';
export const BTC_CODE = 'BTC';
export const LTC_CODE = 'LTC';
export const ETH_CODE = 'ETH';
export const DOGE_CODE = 'DOGE';


export const companyInfoDefault = {
  companyName: '',
  countryCode: '',
  country: '',
  postalCode: '',
  address: '',
  addressDetails: '',
  city: '',
  stateRegion: '',
  vatId: '',
  purchaseOrder: ''
};

export const paymentInfoDefault = {
  plan: '',
  profilesCount: 0,
  additionalProfiles: 0,
  additionalUsers: 0,
  prolongMonths: 0,
  discount: 0,
  paymentMethod: 'unlimint', // default 'unlimint'
  countryCode: null,
  promocode: null,
  isCustomTariff: false
};

export const paymentSummaryDefault = {
  planBasePrice: 0,
  additionalUsersPrice: 0,
  additionalProfilesPrice: 0,
  paymentFee: 0,
  paymentFeePercentage: 0,
  discount: 0,
  discountPercentage: 0,
  countryFee: 0,
  countryFeePercentage: 0,
  total: 0,
  availableDays: 0
}


  //при изменении в paymentMethods местами или добавлении проверить функцию setPaymentProvider в src/mixins/setPaymentsMethods.js
export const paymentMethods = [
  PAYMENT_METHOD_UNLIMINT_NAME,
  PAYMENT_METHOD_STRIPE,
  PAYMENT_METHOD_WALLET_NAME,
  PAYMENT_METHOD_USDT_NAME,
  PAYMENT_METHOD_CRYPTO_NAME
]
